import React from "react";
import "./Checkout.css";
import { useStateValue } from "../StateProvider";
import CheckoutProduct from "./CheckoutProduct";
import SubCheckout from "./SubCheckout";

function CheckOut() {
  const [{ cart }] = useStateValue();
  return (
    <div className="checkout">
      <div className="checkout_left">
      <img
        className="checkout-ad"
        src="https://m.media-amazon.com/images/I/21ZTKqJehBL.jpg"
        alt="ads"
      />
      {cart?.length === 0 ? (
        <div>
          <h2>Your Shopping Cart is Empty</h2>
        </div>
      ) : (
        <div>
          <h2 className="checkout_title">Your Shopping Cart</h2>
          {cart?.map((item, key) => (
            <CheckoutProduct
              key={key}
              id={item.id}
              title={item.title}
              image={item.image}
              price={item.price}
              rating={item.rating}
            />
          ))}
        </div>
      )}
      </div>
     <div className="checkout_right">
      {cart.length>0 &&(
        <div>
          <SubCheckout/>
        </div>
      )}
     </div>
    </div>
  );
}

export default CheckOut;
